import { render } from "./DashboardTabs.vue?vue&type=template&id=39da178a&scoped=true&ts=true"
import script from "./DashboardTabs.vue?vue&type=script&lang=ts"
export * from "./DashboardTabs.vue?vue&type=script&lang=ts"

import "./DashboardTabs.vue?vue&type=style&index=0&id=39da178a&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39da178a"]])

export default __exports__